<template>
    <div class="entity-compare">
        <v-row class="entity-compare-header m-0">
            <v-col cols="6" class="header-col left"><h4>Before</h4></v-col>
            <v-col cols="6" class="header-col right"><h4>After</h4></v-col>
        </v-row>
        <v-row class="entity-compare-body m-0">
            <v-col cols="6" class="body-col left">
                <notification-pharmacy-groups-approval-request-form
                    :store="pharmacyGroups"
                    :is-afert="true"
                ></notification-pharmacy-groups-approval-request-form>
            </v-col>

            <v-col cols="6" class="body-col right">
                <notification-pharmacy-groups-approval-request-form
                    :store="pharmacyGroupsSnapShot"
                ></notification-pharmacy-groups-approval-request-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'NotificationPharmacyGroupsApprovalRequest',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        notification() {
            return this.$store.state.notifications.current;
        },
        pharmacyGroups() {
            return this.$store.state.notification_pharmacy_group.pharmacy_group;
        },
        pharmacyGroupsSnapShot() {
            return this.$store.state.notification_pharmacy_group.pharmacy_groupSnapShot;
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>
